import React from 'react';
import { StreamInfo } from '../types';

interface StreamListProps {
  streams: StreamInfo[];
  selectedStreamId: string | null;
  onSelect: (streamId: string) => void;
  loading: boolean;
  onRefresh: () => void;
  lastUpdated?: number | null;
}

const formatDate = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString();
};

export const StreamList: React.FC<StreamListProps> = ({
  streams,
  selectedStreamId,
  onSelect,
  loading,
  onRefresh,
  lastUpdated,
}) => {
  return (
    <div className="stream-list-card">
      <div className="card-header">
        <div>
          <h2>Active Streams</h2>
          <p className="card-subtitle">Real-time stream list from Debug API</p>
        </div>
        <div className="card-actions">
          <button className="ghost-button" onClick={onRefresh} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
      </div>
      {lastUpdated && (
        <p className="muted-text">Last updated: {new Date(lastUpdated).toLocaleTimeString()}</p>
      )}
      <div className="stream-list">
        {loading ? (
          <div className="empty-state">Loading stream list...</div>
        ) : streams.length === 0 ? (
          <div className="empty-state">No active streams. Please push audio via Push Demo first.</div>
        ) : (
          streams.map((stream) => (
            <button
              key={stream.streamId}
              className={`stream-item ${selectedStreamId === stream.streamId ? 'selected' : ''}`}
              onClick={() => onSelect(stream.streamId)}
            >
              <div className="stream-item__primary">
                <div className="stream-id">{stream.streamId}</div>
                <div className={`status-badge status-${String(stream.status).toLowerCase()}`}>
                  {stream.status}
                </div>
              </div>
              <div className="stream-item__meta">
                <span>Created: {formatDate(stream.createdAt)}</span>
                <span>Subscribers: {stream.subscriberCount}</span>
              </div>
              <div className="stream-item__meta">
                <span>Frames: {stream.framesReceived}</span>
                <span>Bytes: {stream.bytesReceived}</span>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

